import React from 'react';
export default ({ className }: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.348"
    height="15.261"
    viewBox="0 0 20.348 15.261"
    className={className}
  >
    <g transform="translate(-1060 412)">
      <g transform="translate(1060 -412)">
        <path
          d="M20.348,13.272a1.272,1.272,0,0,1-1.272,1.272H1.272a1.272,1.272,0,0,1,0-2.543h17.8A1.272,1.272,0,0,1,20.348,13.272Zm-1.272,5.087H1.272a1.272,1.272,0,0,0,0,2.543h17.8a1.272,1.272,0,1,0,0-2.543Zm0,6.359H1.272a1.272,1.272,0,0,0,0,2.543h17.8a1.272,1.272,0,1,0,0-2.543Z"
          transform="translate(0 -12)"
          fill="#505050"
        />
      </g>
    </g>
  </svg>
);
